import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../commons/layout/layout";
import { useTranslation } from "react-i18next";
import { Breadcrumb, BreadCrumbItem } from "../commons/breadcrumb/breadcrumb";
import { Content } from "../commons/content/content";
import { ContentHeader } from "../commons/content/contentHeader";

export const Page404 = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");

  const title = t("general.404");

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{t("general.404")}</BreadCrumbItem>
          </Breadcrumb>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content md={8}>
          <ContentHeader title={title} />
          <p>{t("general.404.description")}</p>
        </Content>
      </LayoutContent>
    </Layout>
  );
};
